import { useCallback, useRef } from 'react';

export type noop = (...args: any[]) => any;

const usePersistCallback = <T extends noop>(fn: T) => {
  const ref = useRef<any>(() => {
    throw new Error('Cannot call function while rendering.');
  });
  ref.current = fn;

  const persistFn = useCallback(((...args) => ref.current(...args)) as T, [ref]);
  return persistFn;
};

export default usePersistCallback;
